require('./bootstrap');
import Plyr from 'plyr';

window.currentUrl = `${location.origin}${location.pathname}`;
feather.replace();

$('#flash-overlay-modal')
    .modal();
$('[data-toggle="tooltip"]')
    .tooltip();
$('div.alert')
    .not('.alert-important')
    .delay(3000)
    .fadeOut(350);

// lightbox 설정

// 링크가 없는 이미지에 링크를 만들어준다.
const noLinkImages = document.querySelectorAll('.entry-content .post-content img, .entry-content .entry-single-content img');
if (noLinkImages && noLinkImages.length > 0) {
    for (const image of noLinkImages) {
        if (image.parentNode.nodeName !== 'A') {
            const wrapper = image.parentNode;
            const link = document.createElement('a');
            link.href = image.src;
            link.classList.add('gallery');
            wrapper.insertBefore(link, image);
            link.appendChild(image);
        }
    }
}

window.searchToggle = () => {
    const searchSection = document.getElementById('search-section');
    if (searchSection.style.display === 'none') {
        searchSection.style.display = '';
        const esc = window.addEventListener('keyup', e => {
            if (e.key === 'Escape') {
                searchToggle();
            }
        });
    } else {
        searchSection.style.display = 'none';
    }
};

// checkall
function syncCheckbox(obj) {
    const checkboxes = document.querySelectorAll('table tbody input[type="checkbox"]');
    if (checkboxes && checkboxes.length > 0) {
        for (const item of checkboxes) {
            item.checked = obj.checked;
        }
    }
}

const checkAll = document.getElementById('checkall');

if (checkAll) {
    checkAll.addEventListener('click', (e) => {
        syncCheckbox(checkAll);
    });
}

// toast
window.showAlert = (title, message, delaytime = null) => {
    const tpl = document.querySelector('#toast-tpl')
                        .content
                        .cloneNode(true);
    const toast = tpl.querySelector('.toast');
    const id = `toast-${moment()
        .format('x')}`;
    toast.id = id;
    toast.querySelector('.toast-header strong').textContent = title;
    toast.querySelector('.toast-header small').textContent = moment()
        .format('h:mm:ss a');
    toast.querySelector('.toast-body').innerHTML = message;

    switch (title) {
        case '오류':
            toast.querySelector('.toast-header')
                 .classList
                 .add('bg-danger', 'text-white');
            break;
        case '성공':
        case '완료':
            toast.querySelector('.toast-header')
                 .classList
                 .add('bg-success', 'text-white');
            break;
        default:
            toast.querySelector('.toast-header')
                 .classList
                 .add('bg-info');
    }

    if (delaytime && delaytime > 0) {
        $(toast)
            .toast({
                autohide: true,
                delay: delaytime * 1000
            });
        setTimeout(() => {
            document.getElementById(id)
                    .remove();
        }, (parseInt(delaytime) * 1000) + 500);
    } else {
        $(toast)
            .toast({
                autohide: false,
                delay: 500
            });
    }

    const tg = document.querySelector('.alert-zone');
    if (tg) {
        tg.appendChild(tpl);
        tg.style.display = '';
    } else {
        document.body.appendChild(tpl);
    }

    feather.replace();
    $('.toast')
        .toast('show');
};

$('.toast')
    .on('hidden.bs.toast', (e) => {
        const item = document.getElementById(e.target.id);
        if (item) {
            item.remove();
        }

        const tg = document.getElementById('alert-zone');
        if (tg) {
            const cards = tg.querySelectorAll('.toast');
            if (!cards || cards.length === 0) {
                tg.style.display = 'none';
            }
        }
    });

const sidemenuLinks = document.querySelectorAll('aside .nav-link');
if (sidemenuLinks && sidemenuLinks.length > 0) {
    for (const item of sidemenuLinks) {
        if (item.href === currentUrl) {
            item.classList.add('active');
            if (item.closest('.nav-children.collapse')) {
                const parentActiveMenu = item.closest('.nav-children.collapse').parentNode.firstElementChild;
                $(parentActiveMenu).collapse('show');
                parentActiveMenu.classList.add('active', 'show');
                parentActiveMenu.setAttribute('aria-expanded', 'true');
                parentActiveMenu.nextElementSibling.classList.add('show');
            }
        }
    }
}

const sideMenuToggler = document.querySelector('[data-show-sidemenu]'); // admin sidemenu
if (sideMenuToggler) {
    function toggleSideMenu() {
        const status = sideMenuToggler.dataset.showSidemenu;
        if ( status === 'true' ) {
            sideMenuToggler.setAttribute('data-show-sidemenu', 'false');
            sideMenuToggler.setAttribute('aria-expanded', 'false');
            sideMenuToggler.innerHTML = '<i data-feather="chevron-right">';
            anime({
                targets: document.querySelector('aside'),
                right: 0,
                easing: 'easeInOutBack',
                duration:500
            });
        } else {
            sideMenuToggler.setAttribute('data-show-sidemenu', 'true');
            sideMenuToggler.setAttribute('aria-expanded', 'true');
            sideMenuToggler.innerHTML = '<i data-feather="chevron-left">';
            anime({
                targets: document.querySelector('aside'),
                right: '-100vw',
                easing: 'easeInOutBack',
                duration:500
            });
        }

        feather.replace();
    }

    sideMenuToggler.addEventListener('click', toggleSideMenu);
}

// 네비게이션 active

const setChlidNavPosition = el => {
    const bodyWidth = document.body.getBoundingClientRect().width;
    if (bodyWidth > 480) {
        return false;
    }

    const rightStartPosixionX = Math.floor(bodyWidth / 2);
    const depth0 = el.closest('.nav-depth-0');
    if (depth0) {
        const depth0PositionX = depth0.getBoundingClientRect().x;
        if (depth0PositionX >= rightStartPosixionX) {
            const lastChildMenu = el.querySelector('.nav-child[data-depth="2"]');
            if (lastChildMenu) {
                lastChildMenu.style.left = `-${rightStartPosixionX}px`;
            }
        }
    }
};

function showMenu(el) {
    mainNavInit();
    if (el.closest('.nav-depth-0')) {
        el.closest('.nav-depth-0')
          .classList
          .add('show');
    }
    !el.classList.contains('show')
    ? el.classList.add('show')
    : '';
    // setChlidNavPosition(el);

}

function hideMenu(el) {
    el.classList.remove('show');
    el.classList.remove('selected');
}

function toggleMenu() {
    const nav = document.getElementById('main-navigation');
    nav.classList.toggle('show');
}

function mainNavInit() {
    const mainNav = document.getElementById('main-navigation');
    if (!mainNav) {
        return;
    }
    const visibleMenus = mainNav.querySelectorAll('.show, .selected');
    if (visibleMenus && visibleMenus.length > 0) {
        for (const vm of visibleMenus) {
            hideMenu(vm);
        }
    }
}

const mainNavToggler = document.getElementById('mobile-nav-toggler');
if (mainNavToggler) {
    mainNavToggler.onclick = () => {
        mainNavToggler.classList.toggle('is-active');
        toggleMenu();
    };
}

const mainNav = document.getElementById('main-navigation');
if (mainNav) {
    const elems = mainNav.querySelectorAll('nav[data-nav-name="main"] > .nav-item');
    for (const el of elems) {
        const subnav = el.querySelector('.nav-child');
        if (subnav) {
            el.addEventListener('mouseover', (e) => {
                showMenu(el);
                const subnavItems = subnav.querySelectorAll('.nav-item');
                for (const submenu of subnavItems) {
                    submenu.addEventListener('mouseover', evt => {
                        showMenu(evt.target);
                    });
                }
            });
        }
    }

    const mainNavLinks = mainNav.querySelectorAll('.nav-link');
    const mainNavLinkHandler = (e) => {
        e.preventDefault();

        const link = e.currentTarget;
        const menu = e.target.closest('.nav-item');
        mainNavInit();

        if (link.id === 'search-toggle') {
            return searchToggle();
        }

        menu.classList.toggle('selected'); // 현재 선택 여부 표시

        if (!menu.querySelector('.nav-child')) {
            location.href = link.href;
        } else {
            menu.classList.add('show');
            if (menu.closest('.nav-child')) {
                showMenu(menu.closest('.nav-item'));
            }
        }
    };

    for (const link of mainNavLinks) {
        link.addEventListener('touchend', e => {
            mainNavLinkHandler(e);
        }, false);
        link.addEventListener('click', e => {
            mainNavLinkHandler(e);
        });
    }

    // 윈도우 스크롤 시 메인 네이게이션 위치 조정
    window.addEventListener('scroll', (e) => {
        // eslint-disable-next-line no-shadow
        const mainNav = document.getElementById('main-nav-wrap');
        if (window.outerWidth > 480) {
            if (window.scrollY > 150) {
                mainNav.classList.add('on-top', 'animated', 'fadeInDown');
            } else {
                mainNav.classList.contains('on-top')
                ? mainNav.classList.remove('on-top', 'animated', 'fadeInDown')
                : '';
            }
        }
    });

    if (mainNavLinks && mainNavLinks.length > 0) {
        for (const link of mainNavLinks) {
            if (decodeURIComponent(link.href) === decodeURIComponent(location.href)) {
                if (link.closest('.nav-depth-0')) {
                    link.closest('.nav-depth-0')
                        .classList
                        .add('active');
                } else if (link.closest('.nav-item')) {
                    link.closest('.nav-item')
                        .classList
                        .contains('nav-depth-0')
                    ? link.closest('.nav-item')
                          .classList
                          .add('active')
                    : '';
                }
            }
        }
    }
}

window.addEventListener('click', (e) => {
    if (!e.target.closest('#main-navigation')) {
        mainNavInit();
    }
});

// 사이드메뉴
const sidemenus = document.querySelectorAll('#front-sidemenu .nav-link.active');
if (sidemenus.length) {
    for (const menu of sidemenus) {
        if (decodeURIComponent(menu.href) === decodeURIComponent(location.href)) {
            const collapseMenu = menu.closest('.collapse');
            if (collapseMenu) {
                $(collapseMenu)
                    .collapse('show');
            }
        }
    }
}

// go top 버튼
const goTopBtn = document.getElementById('go-top');
if (goTopBtn) {
    goTopBtn.addEventListener('click', () => {
        window.scrollTo(0, 0);
    });
}

// 관리자모드 네비게이션
const adminSideMenu = document.getElementById('adminSideMenu');
if (adminSideMenu) {
    const menulinks = adminSideMenu.querySelectorAll('.nav-link');
    if (menulinks.length) {
        let url = `$location.origin}${location.pathname}`;
        if (url !== location.href) {
            url = location.href;
        }
        for (const link of menulinks) {
            if (link.href === url) {
                link.classList.add('active');
                if (link.closest('.collapse')) {
                    $(link.closest('.collapse'))
                        .collapse('show');
                }
            }
        }
    }
}

// AnimateCss 함수 확장
$.fn.extend({
    animateCss(animationName, callback) {
        const animationEnd = (function (el) {
            const animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd'
            };

            for (const t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        }(document.createElement('div')));

        this.addClass(`animated ${animationName}`)
            .one(animationEnd, function () {
                $(this)
                    .removeClass(`animated ${animationName}`);

                if (typeof callback === 'function') callback();
            });

        return this;
    }
});

async function onAirToggle(status) {

    const target = document.getElementById('on-air');
    const endpoint = `/api/on-air/toggle`;

    try {
        const res = await axios.post(endpoint, {status: status});
        switch (res.data) {
            case 'on' :
                target.classList.remove('off-live');
                break;
            case 'off':
                target.classList.add('off-live');
                break;
        }

    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
    }
}


function checkOnAirStatus() {
    // 인터넷 방송 상황 체크
    const toggleSwitch = document.getElementById('on-air-toggle');
    const target = document.getElementById('on-air');

    axios.get('/api/on-air/check')
         .then(r => {
             if (target) {
                 if (r.data.onairStatus) {
                     target.classList.remove('off-live');
                 } else {
                     target.classList.add('off-live');
                 }
             }
             if (toggleSwitch) {
                 toggleSwitch.checked = r.data.onairStatus;
             }
         })
         .catch(err => {
             console.log(err);
             alert('동작 오류!');
         });

}

async function setLiveStreamEndpoint(endpoint) {
    try {
        const res = await axios.post('/live-stream/', {live_stream_endpoint: endpoint});
        return res.status === 200;
    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
        return false;
    }
}

checkOnAirStatus();

const onAirToggler = document.getElementById('on-air-toggle');
if (onAirToggler) {
    onAirToggler.addEventListener('click', async function () {
        if (this.checked) {
            const streamEndpoint = document.getElementById('live-stream-endpoint');
            const streamEndpointStatus = document.getElementById('live_stream_endpoint_status');
            if (!streamEndpoint.value || streamEndpoint.value.length === 0) {
                streamEndpointStatus.innerText = '유튜브 스트리밍 주소를 입력하세요.';
                streamEndpointStatus.classList.add('text-danger');
                streamEndpoint.classList.add('border-danger');
                streamEndpoint.focus();
                this.checked = false;
                return false;
            }
            try {
                const result = await setLiveStreamEndpoint(streamEndpoint.value);
                if (result) {
                    await onAirToggle('on');
                    streamEndpointStatus.innerText = 'OK';
                    streamEndpointStatus.classList.add('text-success');
                }
            }
            catch (e) {
                console.log(e.response ? e.response : (e.request ? e.request : e));
                alert('주소 등록 오류 발생!');
                await onAirToggle('off');
            }
        } else {
            await onAirToggle('off');
        }
    });
}

const liveStreamPlayer = document.getElementById('live-stream-player');
if (liveStreamPlayer) {

    axios.get('/live-stream')
         .then(r => {

             if (r.data) {
                 liveStreamPlayer.classList.add('plyr__video-embed');
                 liveStreamPlayer.dataset.plyrProvider = 'youtube';
                 liveStreamPlayer.dataset.plyrEmbedId = r.data.endpoint;

                 const player = new Plyr(liveStreamPlayer);

                 player.on('ready', event => {
                     const instance = event.detail.plyr;
                     instance.play();
                 });
             }
         })
         .catch(e => {
             console.log(e.response ? e.response : (e.request ? e.request : e));
         });
}

const audioPlayer = document.getElementById('audio-player');
if (audioPlayer) {
    const audioPlyr = new Plyr(audioPlayer);
}

const videoPlayer = document.getElementById('video-player');
if (videoPlayer) {
    const videoPlyr = new Plyr(videoPlayer);
}


window.setHomepage = function (url) {
    const agent = window.navigator.userAgent;
    if (agent.match(/MSIE/g)) {
        if (document.all) {
            document.body.style.behavior = 'url(#default#homepage)';
            document.body.setHomePage(url);

        } else if (window.sidebar) {
            if (window.netscape) {
                try {
                    netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');
                }
                catch (e) {
                    alert('this action was aviod by your browser，if you want to enable，please enter about:config in your address line,and change the value of signed.applets.codebase_principal_support to true');
                }
            }
            var prefs = Components.classes['@mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch);
            prefs.setCharPref('browser.startup.homepage', url);
        }
    } else {
        alert('보안 상의 이유로 이 기능은 현재 사용중인 브라우저에서 사용할 수 없습니다.');
    }
};

window.trimRight = (str) => str.replace(/\s*$/g, '');

// 뒤의 공백 문자열을 제거
window.trimLeft = (str) => str.replace(/^\s*/g, '');

// 앞뒤 공백문자열을 제거
window.trim = (str) => str.replace(/(^\s*)|(\s*$)/gi, '');

const tinymceConfig = {
    relative_urls: false,
    selector: 'textarea#content:not(.no-editor)',
    content_css: '/assets/css/app.css',
    language: 'ko_KR',
    menubar: false,
    statusbar: true,
    resize: true,
    height: 700,
    allow_script_urls: true,
    allow_html_in_named_anchor: true,
    draggable_modal: true,
    entity_encoding: 'raw',
    extended_valid_elements: 'script[src|type|language]',
    plugins: 'paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    toolbar: [
        'formatselect fontsizeselect fontselect',
        'removeformat | forecolor backcolor | bold italic blockquote | indent outdent | alignleft alignjustify aligncenter alignright | bullist numlist | media link table code'
    ],
    toolbar_sticky: true,
    quickbars_insert_toolbar: false,
    quickbars_selection_toolbar: 'bold italic | quicklink h1 h2 h3 h4 h5 h6 blockquote | removeformat',
    toolbar_drawer: 'sliding',
    branding: false,
    fix_list_elements: true,
    schema: 'html5',
    content_style: 'body { padding: 10px; font-size:16px; background-color:white;box-shadow:0;',
    fontsize_formats: '14px 16px 18px 24px 36px 48px',
    font_formats: '고딕=Lato, Noto Sans KR, sans-serif;명조=Noto Serif KR, serif;',
    style_formats: [
        {
            title: '제목',
            items: [
                {
                    title: 'Heading 1',
                    format: 'h1'
                },
                {
                    title: 'Heading 2',
                    format: 'h2'
                },
                {
                    title: 'Heading 3',
                    format: 'h3'
                },
                {
                    title: 'Heading 4',
                    format: 'h4'
                },
                {
                    title: 'Heading 5',
                    format: 'h5'
                },
                {
                    title: 'Heading 6',
                    format: 'h6'
                }
            ]
        },
        {
            title: 'Inline',
            items: [
                {
                    title: 'Bold',
                    format: 'bold'
                },
                {
                    title: 'Italic',
                    format: 'italic'
                },
                {
                    title: 'Underline',
                    format: 'underline'
                },
                {
                    title: 'Strikethrough',
                    format: 'strikethrough'
                },
                {
                    title: 'Superscript',
                    format: 'superscript'
                },
                {
                    title: 'Subscript',
                    format: 'subscript'
                },
                {
                    title: 'Code',
                    format: 'code'
                }
            ]
        },
        {
            title: '블럭',
            items: [
                {
                    title: 'Paragraph',
                    format: 'p'
                },
                {
                    title: 'Blockquote',
                    format: 'blockquote'
                },
                {
                    title: 'Div',
                    format: 'div'
                },
                {
                    title: 'Pre',
                    format: 'pre'
                }
            ]
        },
        {
            title: '정렬',
            items: [
                {
                    title: 'Left',
                    format: 'alignleft'
                },
                {
                    title: 'Center',
                    format: 'aligncenter'
                },
                {
                    title: 'Right',
                    format: 'alignright'
                },
                {
                    title: 'Justify',
                    format: 'alignjustify'
                }
            ]
        }
    ]

};

tinymce.init(tinymceConfig);



// 미디어 라이브러리 컨트롤
window.loadLibrary = async (pageUrl, favorite = false) => {
    const target = document.querySelector('#media-items .row');

    if (target.querySelector('.card-img-top')) {
        target.innerHTML = '<div class="col"><img src="/images/loading50.gif" alt="loading..." class="d-flex mx-auto my-5"></div>';
    }

    if (pageUrl === undefined || pageUrl === null ) {
        pageUrl = '/admin/media-library?page=1';
    }

    if ( favorite === true ) {
        pageUrl += '&favorite=1';
    }

    try {
        const response = await axios.get(pageUrl);
        const {data} = response;
        const {prev_page_url, next_page_url} = data;
        const code = document.createDocumentFragment();

        for (const el of data.data) {
            const {
                id, filename, mimetype, size, path, url
            } = el;
            const tag = document.querySelector('#media-library-card-tpl')
                                .content
                                .cloneNode(true);
            const card = tag.querySelector('.card');
            const thumbnailWrapper = card.querySelector('.img-wrapper');
            const thumbnail = thumbnailWrapper.querySelector('img.thumbnail');
            const fileIcon = thumbnailWrapper.querySelector('.file-icon');
            if (mimetype.split('/')[0] === 'image') {
                thumbnail.alt = filename;
                thumbnailWrapper.style.backgroundImage = `url(${decodeURIComponent(el.url)})`;
                fileIcon.remove();
            } else {
                thumbnail.remove();
            }

            const cardBody = card.querySelector('.card-body');
            const filenameTag = cardBody.querySelector('.filename');
            filenameTag.innerHTML = `${filename}(${FileSize(size, true)})`;

            const addToBody = cardBody.querySelector('.addMedia');
            const mime = mimetype.split('/')[0];
            addToBody.dataset.id = id;
            addToBody.dataset.path = path;
            addToBody.dataset.mimetype = mime;
            addToBody.dataset.filename = filename;
            addToBody.dataset.url = url;

            const addFeaturedImage = cardBody.querySelector('.addFeaturedImage');
            addFeaturedImage.dataset.id = id;
            addFeaturedImage.dataset.path = path;
            addFeaturedImage.dataset.mimetype = mime;
            addFeaturedImage.dataset.filename = filename;
            addFeaturedImage.dataset.url = url;
            addFeaturedImage.onclick = (e) => {
                const tg = document.getElementById('featuredPreview');
                tg.innerHTML = `<img src="${decodeURIComponent(el.url)}" class="w-100 my-1">`;
                document.getElementById('featuredImage').value = path;
                document.getElementById('mediaLibWindow').style.display = 'none';
            };

            code.appendChild(tag);
        }

        const paginate = document.querySelector('#media-library-paginate-tpl')
                                 .content
                                 .cloneNode(true);
        const prevLink = paginate.querySelector('.prev');
        const nextLink = paginate.querySelector('.next');

        if (prev_page_url) {
            prevLink.setAttribute('onclick', `loadLibrary('${prev_page_url}')`);
            prevLink.style.display = '';
        }
        if (next_page_url) {
            nextLink.setAttribute('onclick', `loadLibrary('${next_page_url}')`);
            nextLink.style.display = '';
        }

        target.innerHTML = '';
        target.appendChild(code);
        target.appendChild(paginate);
        feather.replace();

    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
        showAlert('오류', `오류 발생 : ${err.response && err.response.data.message ? err.response.data.message : err.message}`);
    }
};

// 업로드 트리거
$('#uploadTrigger, #featuredImageUploadTrigger')
    .click(() => {
        $('#fileuploadzone')
            .fadeIn();
    });

// 업로드 닫기
$('#closeUploadzone')
    .click(() => {
        $('#fileuploadzone')
            .fadeOut();
    });

// 미디어 라이브러리 트리거
const mediaLibraryTriggers = document.querySelectorAll('button[data-action="media-library-trigger"]');
if ( mediaLibraryTriggers && mediaLibraryTriggers.length > 0 ) {
    for (const mediaLibraryTrigger of mediaLibraryTriggers) {
        mediaLibraryTrigger.addEventListener('click', async e=>{
            e.preventDefault();
            const target = document.getElementById('mediaLibWindow');
            await loadLibrary();
            target.style.display = (target.style.display === 'none') ? '' : 'none';
            // 즐겨찾기 이미지 로딩
            const showFavoriteBtn = target.querySelector('#show-favorites');
            showFavoriteBtn.addEventListener('click', e=>{
                e.preventDefault();
                loadLibrary(null, true);
            });

            // 전체 이미지 로딩
            const showAllMedias = target.querySelector('#show-all-medias');
            showAllMedias.addEventListener('click', e=>{
                e.preventDefault();
                loadLibrary();
            })
        });
    }
}

// 미디어 라이브러리 닫기 버튼
const mediaLibraryCloseBtn = document.getElementById('closeMediaLibrary');
if (mediaLibraryCloseBtn) {
    mediaLibraryCloseBtn.addEventListener('click', e=>{
        document.getElementById('mediaLibWindow').style.display = 'none';
    });
}

const mediaLibWindow = document.getElementById('mediaLibWindow');
if ( mediaLibWindow ) {
    mediaLibWindow.addEventListener('click', e=>{
       if ( e.target.classList.contains('addMedia') ) {
           // 미디어 라이브러리 : 미디어 본문에 추가
        e.preventDefault();
           const {filename, mimetype, url} = e.target.dataset;
           const code = document.createDocumentFragment();

           if (mimetype === 'image') {
               const img = document.createElement('img');
               img.src = decodeURIComponent(url);
               img.classList.add('img-fluid', 'm-1');
               code.appendChild(img);
           } else {
               const link = document.createElement('a');
               link.href = decodeURIComponent(url);
               link.innerHTML = `<i data-feather="file"></i> ${filename}`;
               code.appendChild(link);
           }

           tinyMCE.execCommand('mceInsertContent', false, code.firstElementChild.outerHTML);
           e.currentTarget.style.display = 'none';
       }
    });
}

window.isImage = (mimetype) => {
    const type = mimetype.split('/');
    return type[0] === 'image';
};

window.deleteFile = async (id) => {
    try {
        const data = {
            _token: document.querySelector('meta[name="csrf-token"]').content,
            _method: 'DELETE'
        };

        const r = await axios.post(`/admin/uploads/destroy/${id}`, data);
        console.log(r);

        const fileBox = document.querySelector(`#file-${id}`);
        fileBox.closest('.media-item').remove();
    }
    catch (err) {
        console.error(err.response ?? err);
        showAlert('오류', err.response?.data.message ?? err.message);
    }
};


// Dropzone setting
const previewNode = document.querySelector('#file-row-tpl');
if (previewNode) {
    previewNode.parentElement.style.display = '';
    previewNode.id = '';
    const previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);
    const token = document.head.querySelector('meta[name="csrf-token"]').content;

    let uploadZone = document.querySelector('#fileuploadzone');
    if (!uploadZone) {
        uploadZone = document.body;
    }

    const myDropzone = new Dropzone.Dropzone(uploadZone, {
        url: '/admin/uploads/store', // Set the url
        paramName: 'attachedImage',
        params: {
            _token: token
        },
        acceptedFiles: 'image/*,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.hwp,.txt,.zip, .svg, .hwpx, .zip, .7z, .alz, .rar',
        thumbnailMethod: 'contain',
        thumbnailWidth: 200,
        thumbnailHeight: 150,
        parallelUploads: 20,
        previewTemplate,
        autoQueue: true,
        previewsContainer: '#previews',
        clickable: '.uploadTrigger'
    });

    myDropzone.on('success', (file, responseText) => {
        const res = responseText;
        const self = document.createDocumentFragment()
                             .appendChild(file.previewElement);
        const mediaWindow = document.getElementById('mediaLibWindow');

        self.querySelector('.progress').style.display = 'none';
        self.querySelector('button.delete')
            .setAttribute('data-file-id', res.id);

        if (self.querySelector('button.append')) {
            const appendBtn = self.querySelector('button.append');
            appendBtn.setAttribute('data-file-id', res.id);
            appendBtn.setAttribute('data-file-url', res.url);
            appendBtn.setAttribute('data-file-mime', res.mimetype);
            appendBtn.setAttribute('data-file-name', res.filename);
        }
        if (self.querySelector('button.appendFeatured')) {
            const appendFeaturedImgBtn = self.querySelector('button.appendFeatured');
            appendFeaturedImgBtn.setAttribute('data-file-id', res.id);
            appendFeaturedImgBtn.setAttribute('data-file-url', res.url);
            appendFeaturedImgBtn.setAttribute('data-file-mime', res.mimetype);
            appendFeaturedImgBtn.setAttribute('data-file-name', res.filename);
        }

        if (mediaWindow) {
            let mediaTpl = document.getElementById('media-thumbnail-tpl');
            if (mediaTpl) {
                mediaTpl = mediaTpl.content.cloneNode(true);
                mediaTpl.querySelector('.card').id = `file-${res.id}`;
                const imgTpl = mediaTpl.querySelector('img');
                imgTpl.src = res.path;
                imgTpl.alt = res.filename;

                mediaTpl.querySelector('.filename').textContent = res.filename;
                const addMediaTpl = mediaTpl.querySelector('.addMedia');
                addMediaTpl.dataset.id = res.id;
                addMediaTpl.dataset.path = res.path;
                addMediaTpl.dataset.mimetype = res.mimetype;
                addMediaTpl.dataset.filename = res.filename;

                const addFimg = mediaTpl.querySelector('addFeaturedImage');
                if (addFimg) {
                    addFimg.dataset.id = res.id;
                    addFimg.dataset.path = res.path;
                    addFimg.dataset.mimetype = res.mimetype;
                    addFimg.dataset.filename = res.filename;
                }
                mediaWindow.querySelector('#media-items .row')
                           .insertBefore(mediaTpl, mediaWindow.querySelector('#media-items .row .col-sm-3:first-child'));
            }
        }


        // 미디어 라이브러리 관련
        const mediaLibrary = document.getElementById('mediaLibrarySection');
        if (mediaLibrary) {
            const tpl = document.getElementById('media-file-tpl');
            if (tpl) {
                const tpl2 = tpl.content.cloneNode(true);
                const col = tpl2.querySelector('#file-template');
                col.querySelector('figure').id = `file-${res.id}`;
                col.id = '';

                const imgLink = tpl2.querySelector('a[data-lightbox]');
                if (isImage(res.mimetype)) {
                    tpl2.querySelector('.img-box').style.backgroundImage = `url(${res.url})`;
                    imgLink.dataset.title = res.filename;
                    imgLink.href = res.url;
                    tpl2.querySelector('.fakeimg').alt = res.filename;
                    tpl2.querySelector('i[data-feather="file"]')
                        .remove();
                } else {
                    imgLink.remove();
                }
                tpl2.querySelector('.media-delete-button').setAttribute('onclick', `deleteFile(${res.id})`);
                tpl2.querySelector('button[data-clipboard-text]').dataset.clipboardText = res.url;
                tpl2.querySelector('figcaption p').title = res.filename;
                tpl2.querySelector('figcaption a').href = `/download/${res.id}`;
                tpl2.querySelector('figcaption a').textContent = `${res.filename}(${res.size})`;
                tpl2.querySelector('figcaption p small').textContent = res.created_at;

                const cols = mediaLibrary.querySelectorAll('.media-item');
                if (cols && cols.length > 0) {
                    mediaLibrary.insertBefore(tpl2, mediaLibrary.firstElementChild);
                } else {
                    mediaLibrary.appendChild(tpl2);
                }
                col.classList.add('animated', 'fadeDown');
                setTimeout(() => {
                    col.classList.remove('animated', 'fadeDown');
                }, 500);
            }
        }

        feather.replace();
        self.remove();
    });

    myDropzone.on('error', (file, error) => {
        console.error(error);
        showAlert('오류', error.message );
    })

    myDropzone.on('queuecomplete', () => {
        $('#fileuploadzone')
            .hide();
        if (document.querySelector('button[data-action="media-library-trigger"]')) {
            document.querySelector('button[data-action="media-library-trigger"]')
                    .click();
        }
    });

}

$(document)
    .on('click', 'button.delete', (e) => {
        e.preventDefault();
        const id = e.currentTarget.dataset.fileId;
        const parent = e.currentTarget.closest('.file-row');
        deleteFile(id);
    });

$(document)
    .on('click', 'button.append', (e) => {
        e.preventDefault();
        const url = e.currentTarget.dataset.fileUrl;
        const mimeType = e.currentTarget.dataset.fileMime;
        const filename = e.currentTarget.dataset.fileName;
        let code = '';

        if (mimeType.split('/')[0] === 'image') {
            code = `<div class="text-center"><img src="${decodeURIComponent(`${url}`)}" class="img-fluid center-block" alt="${filename}"></div>`;
        } else {
            code = `<a href="/file/download/${url}">${filename}</a>`;
        }
        tinyMCE.execCommand('mceInsertContent', false, code);
    });

$(document)
    .on('click', 'button.appendFeatured', function (e) {
        e.preventDefault();
        const url = `/storage/${$(this)
            .data('file-url')}`;
        const mimeType = $(this)
            .data('file-mime');

        if ($('#featuredImage').length === 1) {
            if (mimeType.split('/')[0] != 'image') {
                alert('이미지를 선택하세요.');
                return false;
            }
            $('#featuredImage')
                .val(url);
            $('#featuredPreview')
                .empty()
                .append(`<a href="${url}" data-lightbox="lightbox">`
                        + `<img src="${url}" class="img-fluid center-block">`
                        + '</a>');
        }
    });

$(document)
    .on('focusin', (e) => {
        if ($(e.target)
            .closest('.mce-window').length) {
            e.stopImmediatePropagation();
        }
        if ($(e.target)
            .closest('.moxman-window').length) {
            e.stopImmediatePropagation();
        }
    });

window.makeSlug = function (string, opts = null) {
    // some defaults
    let options = {
        sensitive: false,
        replacement: '-',
        truncate: false
    };

    // regex
    let nonWord = /\W/g,
        nonAlpha = /[^a-z0-9-ㄱ-힣]/g,
        whitespace = /\s+/g,
        trim = /^\s+|\s+$/g;

    // replacement charmap
    const map = {
        'À': 'A',
        'Á': 'A',
        'Â': 'A',
        'Ã': 'A',
        'Ä': 'A',
        'Å': 'A',
        'Æ': 'AE',
        'Ç': 'C',
        'È': 'E',
        'É': 'E',
        'Ê': 'E',
        'Ë': 'E',
        'Ì': 'I',
        'Í': 'I',
        'Î': 'I',
        'Ï': 'I',
        'Ð': 'D',
        'Ñ': 'N',
        'Ò': 'O',
        'Ó': 'O',
        'Ô': 'O',
        'Õ': 'O',
        'Ö': 'O',
        'Ø': 'O',
        'Ù': 'U',
        'Ú': 'U',
        'Û': 'U',
        'Ü': 'U',
        'Ý': 'Y',
        'ß': 's',
        'à': 'a',
        'á': 'a',
        'â': 'a',
        'ã': 'a',
        'ä': 'a',
        'å': 'a',
        'æ': 'ae',
        'ç': 'c',
        'è': 'e',
        'é': 'e',
        'ê': 'e',
        'ë': 'e',
        'ì': 'i',
        'í': 'i',
        'î': 'i',
        'ï': 'i',
        'ñ': 'n',
        'ò': 'o',
        'ó': 'o',
        'ô': 'o',
        'õ': 'o',
        'ö': 'o',
        'ø': 'o',
        'ù': 'u',
        'ú': 'u',
        'û': 'u',
        'ü': 'u',
        'ý': 'y',
        'ÿ': 'y',
        'Ā': 'A',
        'ā': 'a',
        'Ă': 'A',
        'ă': 'a',
        'Ą': 'A',
        'ą': 'a',
        'Ć': 'C',
        'ć': 'c',
        'Ĉ': 'C',
        'ĉ': 'c',
        'Ċ': 'C',
        'ċ': 'c',
        'Č': 'C',
        'č': 'c',
        'Ď': 'D',
        'ď': 'd',
        'Đ': 'D',
        'đ': 'd',
        'Ē': 'E',
        'ē': 'e',
        'Ĕ': 'E',
        'ĕ': 'e',
        'Ė': 'E',
        'ė': 'e',
        'Ę': 'E',
        'ę': 'e',
        'Ě': 'E',
        'ě': 'e',
        'Ĝ': 'G',
        'ĝ': 'g',
        'Ğ': 'G',
        'ğ': 'g',
        'Ġ': 'G',
        'ġ': 'g',
        'Ģ': 'G',
        'ģ': 'g',
        'Ĥ': 'H',
        'ĥ': 'h',
        'Ħ': 'H',
        'ħ': 'h',
        'Ĩ': 'I',
        'ĩ': 'i',
        'Ī': 'I',
        'ī': 'i',
        'Ĭ': 'I',
        'ĭ': 'i',
        'Į': 'I',
        'į': 'i',
        'İ': 'I',
        'ı': 'i',
        'Ĳ': 'IJ',
        'ĳ': 'ij',
        'Ĵ': 'J',
        'ĵ': 'j',
        'Ķ': 'K',
        'ķ': 'k',
        'Ĺ': 'L',
        'ĺ': 'l',
        'Ļ': 'L',
        'ļ': 'l',
        'Ľ': 'L',
        'ľ': 'l',
        'Ŀ': 'L',
        'ŀ': 'l',
        'Ł': 'l',
        'ł': 'l',
        'Ń': 'N',
        'ń': 'n',
        'Ņ': 'N',
        'ņ': 'n',
        'Ň': 'N',
        'ň': 'n',
        'ŉ': 'n',
        'Ō': 'O',
        'ō': 'o',
        'Ŏ': 'O',
        'ŏ': 'o',
        'Ő': 'O',
        'ő': 'o',
        'Œ': 'OE',
        'œ': 'oe',
        'Ŕ': 'R',
        'ŕ': 'r',
        'Ŗ': 'R',
        'ŗ': 'r',
        'Ř': 'R',
        'ř': 'r',
        'Ś': 'S',
        'ś': 's',
        'Ŝ': 'S',
        'ŝ': 's',
        'Ş': 'S',
        'ş': 's',
        'Š': 'S',
        'š': 's',
        'Ţ': 'T',
        'ţ': 't',
        'Ť': 'T',
        'ť': 't',
        'Ŧ': 'T',
        'ŧ': 't',
        'Ũ': 'U',
        'ũ': 'u',
        'Ū': 'U',
        'ū': 'u',
        'Ŭ': 'U',
        'ŭ': 'u',
        'Ů': 'U',
        'ů': 'u',
        'Ű': 'U',
        'ű': 'u',
        'Ų': 'U',
        'ų': 'u',
        'Ŵ': 'W',
        'ŵ': 'w',
        'Ŷ': 'Y',
        'ŷ': 'y',
        'Ÿ': 'Y',
        'Ź': 'Z',
        'ź': 'z',
        'Ż': 'Z',
        'ż': 'z',
        'Ž': 'Z',
        'ž': 'z',
        'ſ': 's',
        'ƒ': 'f',
        'Ơ': 'O',
        'ơ': 'o',
        'Ư': 'U',
        'ư': 'u',
        'Ǎ': 'A',
        'ǎ': 'a',
        'Ǐ': 'I',
        'ǐ': 'i',
        'Ǒ': 'O',
        'ǒ': 'o',
        'Ǔ': 'U',
        'ǔ': 'u',
        'Ǖ': 'U',
        'ǖ': 'u',
        'Ǘ': 'U',
        'ǘ': 'u',
        'Ǚ': 'U',
        'ǚ': 'u',
        'Ǜ': 'U',
        'ǜ': 'u',
        'Ǻ': 'A',
        'ǻ': 'a',
        'Ǽ': 'AE',
        'ǽ': 'ae',
        'Ǿ': 'O',
        'ǿ': 'o'
    };

    // replacer
    const mapping = function (c) {
        return map[c] || c;
    };

    if (!string || typeof string !== 'string') return;

    // populate some defaults
    if (opts) for (var key in opts) options[key] = opts[key];

    // case-sensitive or not
    string = string.toLowerCase();

    string = string.replace(trim, '')
                   .replace(nonWord, mapping)
                   .replace(whitespace, options.replacement)
                   .replace(nonAlpha, '');

    // smart truncate
    if (options.truncate && string.length > options.truncate) {
        const cut = string.indexOf('-', options.truncate);
        string = cut === -1 ? string : string.slice(0, cut);
    }

    return string;
};

const datetimepickerConfig = {
    locale: 'ko',
    dayViewHeaderFormat: 'YYYY년 MM월',
    format: 'YYYY-MM-DD HH:mm:ss',
    sideBySide: true,
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-o',
        clear: 'fa fa-trash',
        close: 'fa fa-times'
    }
};

const datetimepickerConfig2 = {
    locale: 'ko',
    dayViewHeaderFormat: 'YYYY년 MM월',
    format: 'YYYY-MM-DD',
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-o',
        clear: 'fa fa-trash',
        close: 'fa fa-times'
    }
};

const dtConfig3 = {
    locale: 'ko',
    dayViewHeaderFormat: 'YYYY년 MM월',
    format: 'YYYY/MM/DD ddd'
};


$('.datepicker')
    .datetimepicker(dtConfig3);
$('.datetimepicker')
    .datetimepicker(datetimepickerConfig);
$('.datetimepicker-dateonly')
    .datetimepicker(datetimepickerConfig2);

window.FileSize = function (bytes, si) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return `${bytes} B`;
    }
    const units = si
                  ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                  : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
};

window.beforeSubmitWarning = function (obj) {
    if (!confirm('이 글을 삭제할까요?')) return false;
    obj.submit();
};

window.replaceClass = function (obj, classFrom, classTo) {
    const t = $(obj);
    if (t.hasClass(classFrom)) {
        t.removeClass(classFrom)
         .addClass(classTo);
    }
};

window.nl2br = (str) => {
    let string = removeNl(str);
    string = string.replace('/\s/gi', '');
    string = stripTag(string);
    string = string.replace(/\n/gi, '<br>');

    return string;
};

window.stripTag = (str) => str.replace(/(<([^>]+)>)/ig, '');

window.removeNl = (str) => str.replace(/\s\n/gi, '');

window.showDateKr = (str) => {
    const dt = new Date(str);

    /* return dt.getFullYear() + '년'  +
     (dt.getMonth() + 1) + '월 ' +
     dt.getDate() + '일 ' +
     dt.getHours() + '시 ' +
     dt.getMinutes() + '분'; */

    return dt.toLocaleString();
};

window.makeFBtag = (response) => {
    const d = response.data;
    const code = [];
    const tg = $('#facebook-feed .feed');


    $.each(d, function () {
        if (this.message && this.type !== 'event') {
            const now = showDateKr(this.created_time);
            const message = this.message.length > 300 ? `${this.message.substring(0, 300)}...` : this.message;
            const html = `${'<div class="row">'
                         + '<div class="col-12 col-lg-4">'
                         + '<div style="max-height:200px;overflow-y:hidden;" class="rounded">'
                         + '<a href="https://facebook.com/'}${this.id}" target="_blank">`
                         + `<img src="${this.full_picture}" class="img-fluid">`
                         + '</a>'
                         + '</div>'
                         + '</div>'
                         + '<div class="col-12 col-lg-8">'
                         + `<p class="text-primary"><b>${now}</b></p>`
                         + `<p><a href="${this.id}" target="_blank">${message}</a></p>`
                         + '</div>'
                         + '</div>';


            code.push(html);
        }
    });
    tg.html(code.join(''));
};

window.makeFacebookEvents = (res) => {
    const d = res.data;
    const tg = $('#facebook-event-feed .feed');
    const code = [];

    $.each(d, function () {
        const html = `${'<div class="col-4">'
                     + '<div class="card event">'
                     + '<img src="'}${this.cover.source}" class="card-img-top" alt="">`
                     + `<h5 class="card-header text-center">${this.name}</h5>`
                     + '<div class="card-body">'
                     + `<p class="card-text">${this.description}</p>`
                     + '<ul class="list-unstyled">'
                     + `<li><b>시작</b> : ${showDateKr(this.start_time)}</li>`
                     + `<li><b>종료</b> : ${showDateKr(this.end_time)}</li>`
                     + `<li><b>장소</b> : ${this.place.name}</li>`
                     + '</ul>'
                     + '</div>'
                     + '</div>'
                     + '</div>';

        code.push(html);
    });

    tg.html(code.join(''));
};

window.showResult = (tag, status) => {
    let tg = $('#series-contents-current .row');

    if (status === 0) {
        tg = $('#series-contents-old');
    }

    tg.html(tag);
};

window.loadSeriesSermons = (page, status) => {
    const current_url = location.origin + location.pathname;

    axios.get(`/api/get/series?page=${page}&ongoing=${status}`)
         .then((res) => {
             const d = res.data;
             const {total} = d.series;
             const {per_page} = d.series;
             const current_page = d.series.currrent_page;
             const {last_page} = d.series;
             const {first_page_url} = d.series;
             const {last_page_url} = d.series;
             const {next_page_url} = d.series;
             const {prev_page_url} = d.series;
             const {data} = d.series;

             let tpl = '';

             if (status === 0) {
                 // 종료된 설교 시리즈
                 tpl = '<div class="row">'
                       + '<div class="col-3"><div class="img-wrap my-2"></div></div>'
                       + '<div class="col">'
                       + '<div class="d-flex flex-column justify-content-center my-2">'
                       + '<h5 class="series-title my-1"></h5>'
                       + '<a href="" class="detail_link">내용 보기</a>'
                       + '</div>'
                       + '</div>'
                       + '</div>';
             } else {
                 // 진행 중 설교 시리즈
                 tpl = '<div class="col-sm-4">'
                       + '<div class="card series-card border rounded-0 mb-4">'
                       + '<div class="img-wrap position-relative"></div>'
                       + '<div class="card-body p-2 text-center">'
                       + '<h5 class="series-title text-center my-3"></h5>'
                       + '<p class="text-danger"><i class="fa fa-circle text-success"></i> '
                       + '<a href="">내용 보기</a>'
                       + '</p>'
                       + '</div>'
                       + '</div>'
                       + '</div>';
             }

             const code = [];

             $.each(data, function () {
                 const epi = $(tpl)
                     .clone();

                 if (status === 0) {
                     epi.find('.img-wrap')
                        .html(`<a href="${current_url}?cid=${this.id}"><img src=${this.thumbnail}"/storage" class="border img-fluid"></a>`);
                     epi.find('.detail_link')
                        .attr('href', `${current_url}?cid=${this.id}`);
                     epi.find('.series-title')
                        .text(this.title);
                     code.push(`<div class="row">${epi.html()}</div>`);
                 } else {
                     epi.find('.card')
                        .attr('onclick', `location.href="${current_url}?cid=${this.id}"`);
                     epi.find('.img-wrap')
                        .attr('style', `height:150px;background-image:url(/storage/${this.thumbnail});background-position:center;background-size:cover;`);
                     epi.find('.series-title')
                        .text(this.title);
                     epi.find('a')
                        .attr('href', `${current_url}?cid=${this.id}`);
                     code.push(`<div class="col-sm-4">${epi.html()}</div>`);
                 }
             });

             showResult(code.join(''), status);

             if (status === 0 && total > per_page) {
                 const pagination = [
                     `<li class="page-item"><a class="page-link" href="${first_page_url}&ongoing=0">처음</a></li>`,
                     `<li class="page-item"><a class="page-link" href="${prev_page_url}&ongoing=0">이전</a></li>`
                 ];

                 for (let i = 1; i <= last_page; ++i) {
                     const active = current_page === i ? 'active' : '';
                     const pcode = `<li class="page-item${active}">`
                                   + `<a class="page-link" href="{{ url()->current() }}?page=${i}&ongoing=0">${i}</a>`
                                   + '</li>';
                     pagination.push(pcode);
                 }
                 pagination.push(`<li class="page-item"><a class="page-link" href="${next_page_url}&ongoing=0">다음</a></li>`
                                 + `<li class="page-item"><a class="page-link" href="${last_page_url}&ongoing=0">마지막</a></li>`);

                 $('#series-pagination .pagination')
                     .html(pagination.join(''));
                 $('#series-pagination')
                     .show();
             }
         });
};

window.getEpisodes = (cid) => axios.get(`/api/get/series/${cid}/episodes`);

$('#next-gen-wrap .photo-item')
    .hover(function () {
        anime({
            targets: this,
            duration: 30,
            scale: 1.2,
            easing: 'linear'
        });
    }, function () {
        anime({
            targets: this,
            duration: 30,
            scale: 1,
            easing: 'linear'
        });
    });

$('.list-thumbnail')
    .hover(function () {
        anime({
            targets: this,
            scale: 1.1
        });
    }, function () {
        anime({
            targets: this,
            scale: 1
        });
    });

window.publishToFacebook = function (obj) {
    const tg = obj.parentNode;
    const url = obj.dataset.fbPublish;
    tg.innerHTML = '<i class="fa fa-circle-o-notch fa-spin fa-fw text-success"></i>';
    axios.post(url)
         .then((r) => {
             const code = `<a href="https://facebook.com/${r.data.fb_post_id}" target="_blank" class="btn btn-sm btn-outline-secondary"><i class="fa fa-link"></i> 보기</a>`;
             tg.innerHTML = code;
         })
         .catch((err) => {
             if (err.response) {
                 alert(err.response.data.message);
             } else {
                 alert(err.message);
             }
             console.log(err);
         });
};

// DOM 삭제
window.removeFadeOut = (dom) => {
    dom.classList.add('animated', 'fadeOutRight');
    setTimeout(() => {
        dom.remove();
    }, 600);
};

window.fadeInDown = (dom) => {
    dom.classList.add('animated', 'fadeInDown');
    setTimeout(() => {
        dom.classList.remove('animated', 'fadeInDown');
    }, 1000);
};


// 헤더이미지 삭제
window.deleteHeaderBg = async (post_id) => {
    if (!confirm('헤더 배경 이미지를 삭제할까요?')) return false;

    const endpoint = `/api/delete-page-header-bg/${post_id}`;
    try {
        const res = await axios.delete(endpoint);
        const previewWrapper = document.querySelector('#header-bg-preview');
        previewWrapper.innerHTML = '';
    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
        // showAlert('오류', '헤더 이미지 삭제 중 오류 발생');
    }
};

// 카테고리 불러오기
window.attachCategoryOption = async (ptype, cat_id = null) => {
    try {
        const res = await axios.get(`/admin/categories/get-category-by-post-type?post_type=${ptype}`);
        const code = ['<option value="">카테고리 선택...</option>'];
        for (const d of res.data) {
            code.push(`<option value="${d.id}">${d.name}</option>`);
        }
        document.getElementById('select-category').style.display = '';
        document.getElementById('post_category').innerHTML = code.join('');
        if (cat_id) {
            console.log(cat_id);
            document.getElementById('post_category').value = cat_id;
        }
    }
    catch (err) {
        alert('카테고리를 로딩 중 오류 발생');
        console.log(err.response ? err.response : (err.request ? err.request : err));
    }
};


// public post 삭제
window.deletePublicPost = async (formEl) => {
    window.event.preventDefault();
    if (!confirm('이 글을 삭제할까요?')) return false;
    try {
        const endpoint = formEl.action;
        const r = await axios.delete(endpoint);
        if (r.status === 204) {
            alert('삭제되었습니다.');
            let pageNo = 'page=1';
            const pageNoArr = location.search.match(/(&page=[\d]+)/gi);
            if (pageNoArr && pageNoArr.length > 0) {
                pageNo = pageNoArr[0].replace(/&/, '');
            }
            location.href = location.origin + location.pathname + '?' + pageNo;
        }
    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
        alert('삭제 오류 발생 : 관리자에게 문의바랍니다.');
    }
};

const publicPostForm = document.getElementById('publicForm');
if (publicPostForm) {
    const publicTinymceConfig = {
        selector: 'textarea#editor-content',
        height: 600,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount emoticons'
        ],
        menubar: false,
        branding: false,
        toolbar_sticky: true,
        toolbar: 'bold italic forecolor backcolor | alignleft aligncenter ' +
                 ' alignright alignjustify | bullist numlist outdent indent |' +
                 ' removeformat | emoticons image media link anchor | code help',
        content_css: [
            '/assets/css/app.css'
        ],
        content_style: 'body {padding:10px;}'
    };

    tinyMCE.init(publicTinymceConfig);

    publicPostForm.addEventListener('submit', async e => {
        e.preventDefault();
        try {
            const fd = new FormData(e.target);
            fd.append('content', tinyMCE.activeEditor.getBody().innerHTML);
            const r = await axios({
                method: 'post',
                url: e.target.action,
                data: fd
            });
            if (r.data.redirectTo) {
                location.href = r.data.redirectTo;
            }
        }
        catch (err) {
            console.log(err.response ? err.response : (err.request ? err.request : err));
            alert('오류 발생. 글을 저장할 수 없습니다.');
        }
    });
}


// embeding 처리 안 된 iframe 처리
const iframeElems = document.querySelectorAll('.post-content iframe');
if (iframeElems && iframeElems.length > 0) {
    for (let elem of iframeElems) {
        if (!elem.parentNode.classList.contains('embed-responsive')) {
            elem.classList.add('embed-responsive-item');
            const wrap = document.createElement('div');
            wrap.classList.add('embed-responsive', 'embed-responsive-16by9');
            elem.parentNode.insertBefore(wrap, elem);
            wrap.appendChild(elem);
        }
    }
}

// 사이드 위젯 배너
async function getSideBanners(position) {
    try {
        const endpoint = '/api/fetch-middle-banners';
        const res = await axios.get(endpoint, {
            params: {
                position: position
            }
        });

        return res.data;

    }
    catch (err) {
        console.log(err.response ? err.response : (err.request ? err.request : err));
        return null;
    }
}

const sideBannerContainer = document.getElementById('side-banner-container');
if (sideBannerContainer) {

    $(sideBannerContainer)
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            speed: 300,
            adaptiveHeight: true,
            fade: true,
            lazyLoad: 'ondemand'
        });

    const sideWidgetBanners = getSideBanners('side.widget');
    sideWidgetBanners.then(response => {
        const tplOrigin = document.getElementById('side-banner-tpl');
        response.forEach(el => {
            const tpl = tplOrigin.content.cloneNode(true);
            const {title, img_url, url, target} = el;
            const link = tpl.querySelector('a');
            const img = tpl.querySelector('img');
            const bannerText = tpl.querySelector('.banner-text');

            link.href = url;
            link.target = target;
            link.title = title;

            if (img_url.length > 0) {
                bannerText.classList.add('sr-only');
                img.src = img_url;
                img.alt = img_url.split('/')[img_url.split('/').length - 1];
                img.title = title;
                img.dataset.lazy = img_url;
            } else {
                img.remove();
                bannerText.textContent = title;
            }

            $(sideBannerContainer)
                .slick('slickAdd', tpl.firstElementChild); //  slick 배너 추가
        });
    });
}

window.stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
};
